const Description = ({description}: IDescription) => {
  return (
    <>
      <div className=" mt-7 overflow-x-hidden">
        <p className=" text-gray-6 mb-5">توضیحات:</p>
        <span className=" whitespace-pre-line">{description}</span>
      </div>
    </>
  );
};

export default Description;
